<template>
  <div class="StudyModules" v-if="selectedStudy && currentTab">
    <v-card class="card-create-step" outlined>
			<v-alert
				class="edit-alert"
				v-model="saveSuccess"
				dismissible
				type="success"
			>
				Changes have been saved.
			</v-alert>
      <!-- <v-card-title>Select Optional Study Modules</v-card-title> -->
			<h2 class="left-align">Select Optional Study Modules</h2>
      <!-- <v-card-subtitle class="left-align">
				Check modules to enable/disable at any time during the study. All modules except the Respondent Nutrition Report may increase time to completion.
			</v-card-subtitle> -->
			<h3 class="left-align">
				Check modules to enable/disable at any time during the study. All modules except the Respondent Nutrition Report may increase time to completion.
			</h3>
			<fieldset class="border-0">
				<legend class="d-sr-only">
					Check modules to enable/disable at any time during the study
				</legend>
      <div
        class="optional-module-step"
        v-for="(optionalModule, i) in this.$createStudyLists.optionalModules"
        :key="optionalModule.name + i"
      >
				<v-row v-if="isModuleAllowed(optionalModule.name)">
          <v-col md="3">
						<v-checkbox
						v-if="optionalModule.name === 'Location' && optionalStudyModules.includes('Source')"
							ref="firstFocusable"
              v-model="optionalStudyModules"
              :label="optionalModule.name"
              :value="optionalModule.name"
              hide-details="auto"
							class="moduleCheckbox"
							:aria-label="optionalModule.name + '. Decription: ' + optionalModule.htmlText"
							disabled
            ></v-checkbox>
						<v-checkbox
						v-else
							ref="firstFocusable"
              v-model="optionalStudyModules"
              :label="optionalModule.name"
              :value="optionalModule.name"
              hide-details="auto"
							class="moduleCheckbox"
							:aria-label="optionalModule.name + '. Decription: ' + optionalModule.htmlText"
            ></v-checkbox>
            <div
              v-if="displayRNRSettings(optionalModule.name)"
              class="rnr-options"
            >
						<fieldset class="border-0">
							<legend class="d-sr-only">
								Respondent Nutrition Report
							</legend>
              <v-radio-group v-model="showRNR" :rules="radioRules">
                <v-radio
                  v-for="(optionRNR, i) in optionsRNR"
                  :key="optionRNR + i"
                  :label="optionRNR"
                  :value="optionRNR"
									:aria-label="optionRNR + '. Decription: ' + optionalModule.htmlText"
                ></v-radio>
              </v-radio-group>
							</fieldset>
            </div>
          </v-col>
          <v-col md="9" cols="12">
            <explanation-box
						:id="'optionalModule-' + i + '-explanation-box'"
							:color="'green'"
							:displayText="optionalModule.htmlText">
						</explanation-box>
          </v-col>
        </v-row>
        <v-divider inset></v-divider>
      </div>
			</fieldset>
      <v-card-actions>
        <v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loadingSave"
          text
          class="btn-default"
          @click="check()"
        >
          Save changes
        </v-btn>
      </v-card-actions>
    </v-card>
		<!-- Cancel pop up -->
		<foe-dialog
      v-model="cancelDialog"		:dialogW="cancelDialog"
      persistent
			max-width="600px"
			class="cancel-dialog"
    >
      <v-card class="cancel-confirm-card">
        <v-card-title>Cancel</v-card-title>
        <v-card-text>Are you sure you want to cancel?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
					<v-btn
            text
						class="btn-default"
            @click="cancelDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
						class="btn-default"
            @click="onCancel()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
  </div>
</template>

<script>
import { moduleService } from '@/services/moduleService.js';
import { utilityService } from '@/services/utilityService.js';
export default {
	name: 'StudyModules',
	props: {},
	data: () => ({
		optionalStudyModules: [],
		showRNR: '',
		loadingSave: false,
		saveSuccess: false,
		radioRules: [v => (v !== '' || 'This section is required')],
		cancelDialog: false,
		studyUuid: '',
		version: ''
	}),
	mounted () {
		// sets the values for the displayed properties from the selected study
		this.changeSelectedFields();
		this.version = this.$store.getters.getSelectedStudy.version
		// showRNR
		const me = this
		if (this.$store.getters.getSelectedStudy.nutritionProfileModuleShowReport === true) {
			me.showRNR = 'Display at the end of the recall'
		} else if (this.$store.getters.getSelectedStudy.nutritionProfileModuleShowReport === false) {
			me.showRNR = 'Do not display at the end of the recall'
		}
		this.$nextTick(function () {
			// 2021.10.20 - Sebastian Calle assisted with the following idea/solution
			// Code that will run only after the entire view has been rendered
			// var b = document.getElementById('form-study-purpose');
			// b.setAttribute('aria-labelledby', 'form-study-purpose-label')
			// 2021.10.25 - Yevgeniy editted above to target class name and remove aria-labelledby attribute for all elements
			// 2022.06.29 - CHT adding to edit study
			var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
			for (let i = 0; i < vRadioGroup.length; i++) {
				vRadioGroup[i].removeAttribute('aria-labelledby');
			}
		});
	},
	watch: {
		optionalStudyModules: function (newVal, oldVal) {
			this.$nextTick(function () {
			// 2021.10.20 - Sebastian Calle assisted with the following idea/solution
			// Code that will run only after the entire view has been rendered
			// var b = document.getElementById('form-study-purpose');
			// b.setAttribute('aria-labelledby', 'form-study-purpose-label')
			// 2021.10.25 - Yevgeniy editted above to target class name and remove aria-labelledby attribute for all elements
			// 2022.06.29 - CHT adding to edit study
				var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
				for (let i = 0; i < vRadioGroup.length; i++) {
					vRadioGroup[i].removeAttribute('aria-labelledby');
				}
			});
			if (this.optionalStudyModules.includes('Source') && !this.optionalStudyModules.includes('Location')) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[0].name);
			}
		}
	},
	computed: {
		selectedStudy: function () {
		// If the selectedStudy changes, the radio buttons and checkbox properties need to be updated.
			if (this.studyUuid !== this.$store.getters.getSelectedStudy.studyUuid) {
				this.changeSelectedFields();
			}
			return this.$store.getters.getSelectedStudy;
		},
		currentTab: function () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};

			this.checkTabMatch(tabPosition);

			return tabPosition;
		},
		studyToSave: function () {
			// eslint-disable-next-line prefer-const
			let temp = JSON.parse(JSON.stringify(this.$store.getters.getSelectedStudy));
			return temp;
		},
		optionsRNR: function () {
			return this.$createStudyLists.optionsRNR;
		}
	},
	methods: {
		async checkTabMatch ({ tabIndex, subTabIndex } = {}) {
			console.log('Edit Study Modules checkTabMatch', tabIndex, subTabIndex);
			var tabsPos = await utilityService.getTabsPositionByName('Edit Study Modules', this.$studyTabConfig);
			if (tabsPos.tabPos === tabIndex && tabsPos.subtabPos === subTabIndex) {
				// What a mess but the virtual dom doesn't give the ability to set the focus
				this.$refs.firstFocusable[0].$el.children[0].children[0].children[0].children[1].focus({ preventScroll: true });
			}
		},
		onOpenCancel () {
			this.cancelDialog = true;
		},
		onCancel () {
			this.$router.push('/landing');
		},
		async check () {
			const me = this;
			this.loadingSave = true;
			// make sure that time values are in unix format
			var unixStartDate = new Date(this.studyToSave.dateStart);
			var unixEndDate = new Date(this.studyToSave.dateEnd);
			this.studyToSave.dateEnd = unixEndDate / 1000;
			this.studyToSave.dateStart = unixStartDate / 1000;
			// save changes in the copy study object
			// console.log('this.optionalStudyModules:', this.optionalStudyModules)
			this.studyToSave.tvModule = this.optionalStudyModules.includes('TV/Computer Use');
			this.studyToSave.sourceModule = this.optionalStudyModules.includes('Source');
			this.studyToSave.locationModule = this.optionalStudyModules.includes('Location');
			this.studyToSave.nutritionProfileModule = this.optionalStudyModules.includes('Respondent Nutrition Report');
			this.studyToSave.nutritionProfileModuleShowReport = this.convertShowRNR(this.showRNR);
			// console.log('	this.studyToSave.nutritionProfileModuleShowReport:', 	this.studyToSave.nutritionProfileModuleShowReport)

			this.studyToSave.eatWithModule = this.optionalStudyModules.includes('Ate with others');
			this.studyToSave.sleepModule = this.optionalStudyModules.includes('Sleep');
			this.studyToSave.supplementModule = this.optionalStudyModules.includes('Supplements');

			await this.$store.dispatch('updateStudy', this.studyToSave)
				.then(async function (response) {
					if (response) {
						me.saveSuccess = true;
					}
					me.loadingSave = false;
					window.scrollTo(0, 0);
				})
				.catch(function (err) {
					me.loadingSave = false;
					window.scrollTo(0, 0);
				});
		},
		displayRNRSettings (currentModule) {
			const studyType = this.selectedStudy.recordStudyType || this.selectedStudy.recallType
			const moduleRnr = moduleService.isModuleRNRAllowed(this.version, studyType);
			const isRnrModule = currentModule === 'Respondent Nutrition Report';
			const isRnrChecked = this.optionalStudyModules.some(element => element === 'Respondent Nutrition Report');

			return isRnrModule && isRnrChecked && moduleRnr.isModuleAllowed && moduleRnr.isFollowupAllowed;
		},
		changeSelectedFields () {
			this.studyUuid = this.studyToSave.studyUuid;
			this.optionalStudyModules = [];

			if (this.studyToSave.tvModule === 'true') {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[3].name);
			}

			if (this.studyToSave.sourceModule === 'true') {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[2].name);
			}

			if (this.studyToSave.locationModule === 'true') {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[0].name);
			}

			if (this.studyToSave.nutritionProfileModule === true) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[4].name);
			}

			if (this.studyToSave.eatWithModule === 'true') {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[1].name);
			}

			if (this.studyToSave.sleepModule === 'true') {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[5].name);
			}

			if (this.studyToSave.supplementModule === 'true') {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[6].name);
			}
		},
		convertShowRNR (showRNR) {
			let nutritionProfileModuleShowReportBoolean = false;
			if (showRNR === 'Display at the end of the recall') {
				nutritionProfileModuleShowReportBoolean = true
			} else if (showRNR === 'Do not display at the end of the recall') {
				nutritionProfileModuleShowReportBoolean = false
			}
			return nutritionProfileModuleShowReportBoolean
		},
		isModuleAllowed: function (moduleName) {
			const studyType = this.selectedStudy.recordStudyType || this.selectedStudy.recallType
			const checkedModuleNames = ['Respondent Nutrition Report', 'Sleep', 'Supplements'];
			const moduleRnr = moduleName === checkedModuleNames[0] && moduleService.isModuleRNRAllowed(this.version, studyType).isModuleAllowed;
			const moduleSleep = moduleName === checkedModuleNames[1] && moduleService.isModuleSleepAllowed(this.version);
			const moduleSupplements = moduleName === checkedModuleNames[2] && moduleService.isModuleSupplementsAllowed(this.version);
			const moduleAnythingElse = !checkedModuleNames.includes(moduleName);

			return moduleRnr || moduleSleep || moduleSupplements || moduleAnythingElse;
		}
	}
};
</script>

<style>
</style>
